/*
  "How to cook it" video module.

  Opens the product's cooking clip in the shared CarniModal (assets/carni-modal.js), which
  already owns focus trapping, the scroll lock, Escape handling and focus restore, so this
  file only has to wire the trigger, the backdrop and playback.

  The theme's <video-element> defers the real <video> until its poster button is pressed, so
  after opening we press that button once. That keeps the clip off the wire until someone
  actually asks for it, which matters because these are 15 to 32 second 1080x1920 files.

  Delegated from the document so it survives the product form and quick view being re-rendered.
*/
(function () {
  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function stop(modal) {
    // Put the clip back to its poster state so reopening does not resume mid-way,
    // and so a backgrounded video is not left decoding.
    var video = modal.querySelector('video');
    if (video) {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }
  }

  function open(trigger) {
    var modal = document.getElementById(trigger.getAttribute('data-carni-cook-open'));
    if (!modal) return;

    // The modal is authored inside the product block, but any ancestor with a transform
    // (this theme wraps product blocks in <motion-element>) becomes the containing block for
    // position:fixed, so inset:0 resolved against a zero-size box and the backdrop never
    // covered the viewport. Reparent to <body> on first open, which is where the theme's
    // other overlays live for exactly this reason. Done lazily so markup stays with the block.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    if (window.CarniModal) {
      window.CarniModal.open(modal, {
        trigger: trigger,
        onClose: function () {
          stop(modal);
        }
      });
    } else {
      modal.hidden = false;
    }

    // Let the modal paint before asking the deferred player to swap the video in.
    var poster = modal.querySelector('.media__poster');
    if (poster) {
      setTimeout(function () {
        try {
          poster.click();
        } catch (e) {}
      }, 60);
    }
  }

  function close(modal) {
    if (window.CarniModal) {
      window.CarniModal.close(modal);
    } else {
      modal.hidden = true;
      stop(modal);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, '[data-carni-cook-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    var closer = closest(event.target, '[data-carni-cook-close]');
    if (closer) {
      event.preventDefault();
      var owned = closest(closer, '[data-carni-cook-modal]');
      if (owned) close(owned);
      return;
    }

    // Tap on the backdrop itself, never on the panel inside it.
    if (event.target.hasAttribute && event.target.hasAttribute('data-carni-cook-modal')) {
      close(event.target);
    }
  });
})();
